var svgCache = {};
export default svgCache;